
import PropTypes from 'prop-types'
import moment from 'moment'
import { Label, FleetIcon } from 'frame/components'
import { getDateColor, obfuscateAgreementNumber } from 'listable'
import { types } from '../../module'
import { createRowSelector } from 'utils'
import { useNavigate, useLocation } from 'react-router-dom'
import ErrorIcon from '@mui/icons-material/Error'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'

import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'

import TableCellView from 'frame/components/table-cell/table-cell'
import { themeV5 } from 'theme/v5'

const Row = ({ item, columns, onView }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const onSafeRowClick = createRowSelector(onView)


  const onViewDocumentsReport = () => {
    navigate(`/reports/documents?registration=${item.registration}`, { label: 'Vehicle Servicing', path: location.pathname })
  }

  return (
    <TableRow
      hover
      sx={{
        boxSizing: 'border-box',
        cursor: 'pointer',
        verticalAlign: 'middle',
        height: '30px',
        borderBottom: '5px solid white',
      }}
      onClick={onSafeRowClick}>
      <TableCell sx={{ bgcolor: 'white', width: '10px', p: 0 }} />
      {columns.accountName && (
        <TableCellView isFirst>
          <FleetIcon fleetName={item.accountName} />
        </TableCellView>
      )}
      {columns.agreementNo && (
        <TableCellView>
          {obfuscateAgreementNumber(item.agreementNo || '-', true)}
        </TableCellView>
      )}
      {columns.registration && (
        <TableCellView>
          {item.registration || '-'}
        </TableCellView>
      )}
      {columns.driverNote && (
        <TableCellView>
          {item.driverNote || '-'}
        </TableCellView>
      )}
      {columns.driver && (
        <TableCellView>
          {item.driver || '-'}
        </TableCellView>
      )}
      {columns.year && (
        <TableCellView>
          {item.year || '-'}
        </TableCellView>
      )}
      {columns.make && (
        <TableCellView>
          {item.make || '-'}
        </TableCellView>
      )}
      {columns.model && (
        <TableCellView>
          {item.model || '-'}
        </TableCellView>
      )}
      {columns.variant && (
        <TableCellView>
          {item.variant || '-'}
        </TableCellView>
      )}
      {columns.fuelType && (
        <TableCellView>
          {item.fuelType || '-'}
        </TableCellView>
      )}
      {columns.costCentre && (
        <TableCellView>
          {item.costCentre || '-'}
        </TableCellView>
      )}
      {columns.controller && (
        <TableCellView>
          {item.controller || '-'}
        </TableCellView>
      )}
      {columns.startDate && (
        <TableCellView>
          {item.startDate ? moment(item.startDate).format('DD/MM/YY') : '-'}
        </TableCellView>
      )}
      {columns.dateOfLastService && (
        <TableCellView>
          {item.dateOfLastService ? moment(item.dateOfLastService).format('DD/MM/YY') : '-'}
        </TableCellView>
      )}
      {columns.serviceOdometer && (
        <TableCellView sx={item.isReliable === false ? {
          fontWeight: 400,
          fontSize: 9,
          lineHeight: '15px',
          letterSpacing: '-2%',
          fontFamily: 'Inter, sans-serif',
          color: themeV5.palette.brand,
        } : {}}>
          {item.isReliable === false &&
            <Tooltip
              title="NOT RELIABLE"
              arrow
              placement="top"
              sx={{
                tooltip: {
                  backgroundColor: '#FFF',
                  color: themeV5.palette.brand,
                  filter: 'drop-shadow(0px 1.5px 1.5px gray)',
                },
                arrow: {
                  color: '#FFF',
                  top: '21px',
                }
              }}>
              <ErrorIcon sx={{
                height: 18,
                marginBottom: -4,
                position: 'absolute',
                marginLeft: '-24px',
                marginTop: '-1px',
              }} />
            </Tooltip>
          }
          {item.serviceOdometer ? parseInt(item.serviceOdometer, 10).toLocaleString('en-NZ') : '-'}
        </TableCellView>

      )}
      {columns.dateOfLastKmReading && (
        <TableCellView>
          {item.dateOfLastKmReading ? moment(item.dateOfLastKmReading).format('DD/MM/YY') : '-'}
        </TableCellView>
      )}
      {columns.sourceOfKmReading && (
        <TableCellView>
          {item.sourceOfKmReading || '-'}
        </TableCellView>
      )}
      {columns.odometer && (
        <TableCellView>
          {item.odometer ? parseInt(item.odometer, 10).toLocaleString('en-NZ') : '-'}
        </TableCellView>
      )}
      {columns.estNextServiceDueDate && (
        <TableCellView>
          {item.estNextServiceDueDate ? (
            <Label
              color={getDateColor(item.estNextServiceDueDate)}
              variant="outlined">
              {moment(item.estNextServiceDueDate).format('DD/MM/YY')}
            </Label>
          ) : '-'}
        </TableCellView>
      )}
      {columns.estServiceDateLogic && (
        <TableCellView>
          {item.estServiceDateLogic || '-'}
        </TableCellView>
      )}

      {columns.maturityDate && (
        <TableCellView>
          {item.maturityDate ? (
            <Label
              color={getDateColor(item.maturityDate)}
              variant="outlined">
              {moment(item.maturityDate).format('DD/MM/YY')}
            </Label>
          ) : '-'}
        </TableCellView>
      )}
      {columns.originalMaturityDate && (
        <TableCellView>
          {item.originalMaturityDate ? moment(item.originalMaturityDate).format('DD/MM/YY') : '-'}
        </TableCellView>
      )}
      {columns.agreementType && (
        <TableCellView>
          {item.agreementType || '-'}
        </TableCellView>
      )}
      {columns.serviceBooked && (
        <TableCellView>
          {item.serviceBooked ? 'Yes' : 'No'}
        </TableCellView>
      )}
      {columns.serviceStatus && (
        <TableCellView>
          {item.serviceStatus || '-'}
        </TableCellView>
      )}
      {columns.bookedDate && (
        <TableCellView>
          {item.bookedDate ? (
            <Label
              variant="outlined">
              {moment(item.bookedDate).format('DD/MM/YY')}
            </Label>
          ) : '-'}
        </TableCellView>
      )}
      {columns.bookedLocation && (
        <TableCellView>
          {item.bookedLocation || '-'}
        </TableCellView>
      )}
      {columns.completedLocation && (
        <TableCellView>
          {item.completedLocation || '-'}
        </TableCellView>
      )}

      {columns.documentsCount && (
        <TableCellView>
          {( item.documentsCount > 0 ? (
            <Tooltip title="View documents">
              <IconButton
                onClick={(event) => {
                  event.stopPropagation() // Prevents the TableRow onClick from being triggered
                  onViewDocumentsReport()
                }}>
                <InsertDriveFileOutlinedIcon sx={{ color: themeV5.palette.primary.main }} />
              </IconButton>
            </Tooltip>
          ) : '-')}
        </TableCellView>
      )}
      {Object.values(columns).some(value => value === true) &&
        (<TableCellView isLast></TableCellView>)
      }
    </TableRow>
  )
}

Row.propTypes = {
  item: types.ModelType.isRequired,
  columns: types.ColumnsType.isRequired,
  onView: PropTypes.func.isRequired,
}

export default Row
